// extracted by mini-css-extract-plugin
export var archiveIconHoverColor = "iltCw";
export var deleteIconHoverColor = "QYwso";
export var mailListItemIsPinned = "s1De5";
export var markAsReadIconHoverColor = "R_Gs1";
export var moveIconHoverColor = "pS604";
export var pinFilledColor = "MWwjW";
export var pinIcon = "loulW";
export var pinIconColor = "xLIlX";
export var visibilityHidden = "hLBV6";